import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

// 🔥 GLOBAL install event capture
window.deferredPrompt = null;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  console.log("🔥 GLOBAL INSTALL EVENT CAUGHT");
  window.deferredPrompt = e;
});

// 🔥 React render
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 🔥 Service Worker register
serviceWorkerRegistration.register();